export const NCD_POLICY_NOTIFICATION_ACTION = 'pro-notification-ncd-policy-clicked';
export const TRACKING_PREFIX = 'NCD Cancellation Policy Notification ';
